module.exports = __webpack_public_path__ + "assets/b29.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b29.png
// module id = 615
// module chunks = 0